<template>
  <div
    :id="modalId"
    :class="classes"
    :style="this.styles"
    tabindex="-1"
    role="dialog"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Cadastrar novo domínio</h5>
          <button type="button" class="close" @click="hide" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <form @submit.prevent="save" class="form-horizontal">
          <div class="modal-body">
            <div class="form-body">
              <div class="form-group row">
                <label class="control-label text-left text-left-m col-md-4"
                  >{{$tc('generic-str.menu.domains', 1)}}</label
                >
                <div class="col-md-12">
                  <input
                    v-model="form.domain"
                    type="text"
                    class="form-control"
                    required
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="hide">
              {{$t('generic-str.cancel')}}
            </button>
            <button
              :disabled="isSending"
              type="submit"
              :class="{ 'qt-loader qt-loader-mini qt-loader-right': isSending }"
              class="btn btn-primary"
            >
              {{$t('generic-str.save')}}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import MailService from '@/services/mail.service';
import Modal from '@/mixins/Modal';

export default {
  components: {
    // VueTelInput,
  },
  mixins: [Modal],
  props: ['id'],
  data() {
    return {
      isSending: false,
      form: {},
    };
  },
  mounted() {
    console.log(this.$store.state.account.id);
  },
  methods: {
    // validDomain(domain) {
    // var re = new RegExp(/^((?:(?:(?:\w[\.\-\+]?)*)\w)+)((?:(?:(?:\w[\.\-\+]?){0,62})\w)+)\.(\w{2,6})$/);
    // return domain.match(re);
    // },
    save() {
      this.isSending = true;
      console.log(JSON.stringify(this.form));
      console.log(localStorage.getItem('yup_chat_token'));
      MailService.putDomains(this.form).then(
        (response) => {
          console.log('successo');
          console.log(response);
          this.$root.$emit('domains.update', 1);
          this.hide();
          this.$toast.show({
            title: this.$t('generic-str.success'),
            content: 'Domínio registrado',
            type: 'success',
          });
          this.form = {};
          this.isSending = false;
        },
        (error) => {
          this.$toast.show({
            title: `${this.$t('sms.infos.filters.status.lbl-error')} ${error.code}`,
            content: error.response.data.message,
            type: 'danger',
          });
          this.isSending = false;
        },
      );
    },
  },
};
</script>
